module.exports = __webpack_public_path__ + "static/img/26827.f1d8712.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/dxsf/26827.png
// module id = dJq9
// module chunks = 0